import { render, staticRenderFns } from "./RequestMethodTag.vue?vue&type=template&id=490d71d2"
import script from "./RequestMethodTag.vue?vue&type=script&lang=js"
export * from "./RequestMethodTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports